module.exports = __webpack_public_path__ + "img/clickncollect.e1d70d6a.svg";